module.exports = __webpack_public_path__ + "img/two.c4f6239c.png";